// Best-effort screen wake lock. Re-acquires on visibility change.

let lock = null;

export async function acquireWakeLock() {
  if (!('wakeLock' in navigator)) return;
  try {
    lock = await navigator.wakeLock.request('screen');
    lock.addEventListener('release', () => { lock = null; });
  } catch (e) {
    console.debug('wake lock denied', e);
  }
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') acquireWakeLock();
});
